import {useLocation, useNavigate} from "react-router-dom";
import { useState} from "react";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const IdentityVerificationApp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    let { state } = location;
    const userId = state?.id;
    const backUrl = state?.backUrl;
    const [showApprove, setShowApprove] = useState(false);
    const [showDenied, setShowDenied] = useState(false);
    const invitationId = state?.backUrl?.state?.invitationId;
    const userTypeId = USER_TYPE_MODEL.VISITOR;
    // Generic modal configuration for approval/denial/comments
    const genericCommentModals = [
        {
            show: showApprove,
            setter: setShowApprove,
            title: 'approve_id_validation',
            description: 'you_can_leave_a_optional_comment',
            status: STATUS_MODEL.VALIDATED,
            required: false,
            successTrans:"has_been_validated_successfully"
        },
        {
            show: showDenied,
            setter: setShowDenied,
            title: 'decline_id_validation',
            description: 'please_provide_a_reason',
            status: STATUS_MODEL.DENIED,
            required: true,
            successTrans:"has_been_denied_successfully"
        },
    ];

    const handleOnBack = () => {
        navigate(backUrl.pathname, {
            state: backUrl.state
        });
    }

    return {
        userId,
        invitationId,
        userTypeId,
        setShowApprove,
        setShowDenied,
        genericCommentModals,
        handleOnBack
    };
}
